var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6d07b7c79b8b72fb7777f365802320c400dc0ef5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["academy@klaviyo-1"]={id:"6d07b7c79b8b72fb7777f365802320c400dc0ef5"};
      